import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface countryState {
  countryCode: string;
}

const initialState: countryState = {
  countryCode: "",
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setCountryCode: (state, action: PayloadAction<string>) => {
      state.countryCode = action.payload;
    },
  },
});

export const { setCountryCode } = countrySlice.actions;
export default countrySlice.reducer;
